import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'

const LoanBankBalanceUI = ({context, loanBankBalance}) =>
  <>
    <CardUI title='Excess Escrow Account Balance' className='g_m_top_100'>
      <table><tbody>
        <tr>
          <td align='right'>Loan Disbursed</td>
          <td align='right'>{loanBankBalance.disbursedTotalF1}</td>
          <td></td>
          <td></td>
        </tr>
        {
          loanBankBalance.loanBalanceList && loanBankBalance.loanBalanceList.length > 1 && loanBankBalance.loanBalanceList.map((loanBalance, i) =>
            <tr key={i} className='g_muted g_small'>
              <td align='right'>{loanBalance.loanName}</td>
              <td align='right'>{loanBalance.disbursedF2}</td>
              <td></td>
              <td></td>
            </tr>
          )
        }
        <tr>
          <td align='right'>Available Bank Balance</td>
          <td></td>
          <td align='right'>
            {loanBankBalance.availableBalance >= 0 ? loanBankBalance.availableBalanceF1 : `(${loanBankBalance.availableBalanceF1})`}
          </td>
          <td></td>
        </tr>
        <tr>
          <td align='right'>DSRA</td>
          <td></td>
          <td align='right'><span className='g_muted g_small g_m_left_100'>Total</span>
            <span className='g_m_left_50'>{loanBankBalance.dsraTotalF1}</span></td>
          <td align='right'><span className='g_muted g_small g_m_left_100'>Current</span>
            <span className='g_m_left_50'>
              {loanBankBalance.dsraCurrent >= 0 ? loanBankBalance.dsraCurrentF1 : `(${loanBankBalance.dsraCurrentF1})`}
            </span>
          </td>
        </tr>
        {
          loanBankBalance.loanBalanceList && loanBankBalance.loanBalanceList.length > 1 && loanBankBalance.loanBalanceList.map((loanBalance, i) =>
            <tr key={i} className='g_muted g_small'>
              <td align='right'>{loanBalance.loanName}</td>
              <td></td>
              <td align='right'>{loanBalance.dsraF2}</td>
              <td align='right'>{loanBalance.dsraCurrentF2}</td>
            </tr>
          )
        }
        <tr>
          <td align='right'><b>Excess Balance</b></td>
          <td></td>
          <td align='right'><b>
            {loanBankBalance.excessBalance >= 0 ? loanBankBalance.excessBalanceF1 : `(${loanBankBalance.excessBalanceF1})`}
          </b></td>
          <td></td>
        </tr>
      </tbody></table>
    </CardUI>
    <CardUI title='Upcoming Payments' className='g_m_top_100'>
      <table>
        <tbody>
          <tr>
            <td align='right'>Use of Proceeds</td>
            <td align='right'><span className='g_muted g_small g_m_left_100'>Total</span>
              <span className='g_m_left_50'>{loanBankBalance.useOfProceedsTotalF1}</span></td>
            <td align='right'><span className='g_muted g_small g_m_left_100'>Unpaid</span>
              <span className='g_m_left_50'>{loanBankBalance.useOfProceedsUnpaidF1}</span></td>
            <td align='right'><span className='g_muted g_small g_m_left_100'>Paid</span>
              <span className='g_m_left_50'>{loanBankBalance.useOfProceedsPaidF1}</span></td>
          </tr>
          {
            loanBankBalance.loanBalanceList && loanBankBalance.loanBalanceList.length > 1 && loanBankBalance.loanBalanceList.map((loanBalance, i) =>
              <tr key={i} className='g_muted g_small'>
                <td align='right'>{loanBalance.loanName}</td>
                <td align='right'>{loanBalance.useOfProceedsF2}</td>
                <td align='right'>{loanBalance.useOfProceedsUnpaidF2}</td>
                <td align='right'>{loanBalance.useOfProceedsPaidF2}</td>
              </tr>
            )
          }
          <tr>
            <td align='right'>Next EMI Payment</td>
            <td align='right'></td>
            <td align='right'>{loanBankBalance.nextEMITotalF1}</td>
            <td></td>
          </tr>
          {
            loanBankBalance.loanBalanceList && loanBankBalance.loanBalanceList.length > 0 &&
            (
              loanBankBalance.loanBalanceList.length > 1 ||
              loanBankBalance.loanBalanceList[0].nextEMIDetails && loanBankBalance.loanBalanceList[0].nextEMIDetails.includes('+')
            ) &&
            loanBankBalance.loanBalanceList.map((loanBalance, i) =>
              <tr key={i} className='g_muted g_small'>
                <td align='right'>{loanBalance.loanName}</td>
                <td></td>
                <td align='right'>{loanBalance.nextEMIF2}</td>
                <td align='right'>{loanBalance.nextEMIDetails}</td>
              </tr>
            )
          }
        </tbody>
      </table>
    </CardUI>
  </>
export default LoanBankBalanceUI
